// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiObtainPreDetermination {
    'fax'?: string;
    'org'?: string;
    'phone'?: string;
    'website'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiObtainPreDetermination>> = [
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "string"
        },
        {
            "name":     "org",
            "baseName": "org",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "website",
            "baseName": "website",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiObtainPreDetermination.attributeTypeMap;
    }
}
